import ErrorIntegrationScreen from "./ErrorIntegrationScreen";


export default ErrorIntegrationScreen;